import React from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
const IconOnline = (props) => {
    const defaultSize = 14;
    const { size, color, bgColor, sx, className, ...restProps } = props;
    return (React.createElement(Box, { component: "span", className: clsx('ui-internal-icon', className), display: "inline-flex", sx: { color, fontSize: size ?? defaultSize, background: bgColor, ...sx }, "aria-hidden": true, ...restProps },
        React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "4", cy: "4", r: "4", fill: "#09A639" }))));
};
export default IconOnline;
